import React from 'react';
import {
	IonLabel,
  IonItem,
  IonIcon,
} from '@ionic/react';
import { loginUrl, signUpUrl } from '../config';
import { logInOutline, logInSharp } from 'ionicons/icons';
// TODO: Get this to work with deeplink
// import { InAppBrowser } from '@ionic-native/in-app-browser';
// const goToSignIn = () => {
//   InAppBrowser.create(loginUrl);
// };
// const goToSignUp = () => {
//   InAppBrowser.create(loginUrl);
// };
const LoggedOutMenuItems: React.FC = () => (
  <>
    {/* <IonItem>
      <IonLabel>
      <IonIcon icon={logInOutline} /><a href={signUpUrl}></a>
      </IonLabel>
    </IonItem> */}
    <IonItem>
      <IonLabel>
      <IonIcon icon={logInOutline} /><a style={{"textDecoration": "none"}}  href={loginUrl}>Sign In/Sign Up</a>
      </IonLabel>
    </IonItem>
  </>
);

export default LoggedOutMenuItems;
